
<div class="row  ">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-6 col-xl-6 col-md-8 col-lg-8 col-sm-8">
            <h4 class="fw-bold">Notes - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-6 col-xl-6 col-md-4 col-lg-4 col-sm-4 text-start text-sm-end p-md-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="Cancel()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />


      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
            <!--<h5 class="fw-bolder  font-size-16">Notes Selection</h5>-->
            <!--<h6>This section allows yout to enter any notes that are necessary to explain the entries in the Financial Statements.</h6>-->
          </div>
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
            <!--<h5 class="fw-bolder font-size-16">Indicates Mandatory field<span class="text-dark">*</span></h5>-->
            <h6>
              <b>Notes menu</b>
            </h6>
            <h6>
              This section allows you to enter any notes that are necessary to explain the entries in the Financial Statements.
            </h6>
          </div>
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
            <!--<h5 class="fw-bolder font-size-16">Indicates Mandatory field<span class="text-dark">*</span></h5>-->
            <h6>
              Tick the appropriate box(es) below to include the entries in the Financial Statements. Mandatory boxes have been pre-selected and cannot be deselected.
            </h6>
          </div>
          <h6>
            <b>Notes sections</b>
          </h6>
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
            <!--<h5 class="fw-bolder font-size-16">Notes sections</h5>-->

          </div>
        </div>
        <div class="row justify-center-content">
          <div class="col-12 col-xxl-11 col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="border border-transparent mt-3" style="height: auto !important">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4" *ngFor="let notes of NotesList">
                  <div class="mt-3 d-lg-flex d-block">
                    <input type="checkbox" class="mx-2 form-check-input" [checked]="notes.IsChecked" [disabled]="notes.isDisabled" (change)="notesCheck($event,notes.MasterId)" tabindex="1"/>
                    <label class="mt-lg-0 mt-0 mt-xl-0">{{notes.NotesDescription}}</label>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <div class="col-12 col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row pt-5">
              <div class="col-12 col-xxl-4 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="col-sm-12 col-md-12 col-xxl-7 col-xl-12 col-lg-12 col-12">
                  <label>Jump to next section</label>
                </div>
              </div>
              <div class="col-12 col-xxl-8 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <select class="form-select" accesskey="jumpDisabale" (change)="jumpNextSection($event)">
                  <option disabled selected>Select Notes section</option>
                  <option *ngFor="let jump of NotejumpList">{{jump.NotesDescription}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12  mt-5">
            <div class="row">
              <div class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <!--<button type="button" class="btn btn-info p-1 ps-3 pe-3 mx-1">Help</button>-->
              </div>
              <div class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 text-end">
                <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="goBack($event)">Back</button>
                <button type="button" class="btn themedefault p-1 ps-3 pe-3 me-0 ms-1" (click)="validationsOfNotesDeselection($event)">Next</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>



  </div>
</div>


<div class="card card-body p-0 d-none" style="height:auto !important">
  <div class="row ">
    <div class="col-12 col-sm-12 col-md-12 col-xxl-2 col-xl-3 col-lg-12 pe-0">
      <nav class="pcoded-navbar">
        <div class="navbar-wrapper">
          <div class="navbar-content scroll-div">
            <div class="">
              <h4 class="border-bottom border-secondary fw-bolder mb-2 pb-2 pt-2">Notes</h4>
            </div>
            <div class="card-header">
              <h5 class="fw-bolder ">
                Notes Selection
              </h5>

            </div>
            <ul class="nav pcoded-inner-navbar">

              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext"><span class="	fa fa-circle me-2" style="font-size:8px"></span> General Information</span></a>
              </li>
              <!--<li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Turnover / revenue</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Employees</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Inventories (Stock)</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Plant Machinery</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Motor Vehicles</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Creditors - within one years</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Operating lease commitments</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Reserves / Retained profit</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Transactions with directors</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Post balance sheet events</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Statement of Compliance</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Operating profit/(loss)</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Taxation</span></a>
              </li>
              <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" class="nav-item">
                <a class="nav-link" [routerLink]="['../accountingperiod']"><span class="pcoded-mtext">- Intangible fixed assets</span></a>
              </li>-->


            </ul>
          </div>
        </div>
      </nav>

    </div>
    <div class="col-12 col-sm-12 col-md-12 col-xxl-10 col-xl-9 col-lg-12 ">
      <div class="row  card-body">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
          <div class="row">
            <div class="col-12 col-xxl-6 col-xl-6 col-md-8 col-lg-8 col-sm-8">
              <h4>Notes - {{commonService.headerName}}</h4>
            </div>
            <div class="col-12 col-xxl-6 col-xl-6 col-md-4 col-lg-4 col-sm-4 text-start text-sm-end p-md-0 pt-2">
              <button type="button" class="btn btn-primary p-1 ps-3 pe-3" title="Back to list" tabindex="-1" (click)="Cancel()"><i class="fa fa-arrow-left"></i></button>
            </div>
          </div>
        </div>
        <hr />


        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
              <!--<h5 class="fw-bolder  font-size-16">Notes Selection</h5>-->
              <!--<h6>This section allows yout to enter any notes that are necessary to explain the entries in the Financial Statements.</h6>-->
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
              <!--<h5 class="fw-bolder font-size-16">Indicates Mandatory field<span class="text-dark">*</span></h5>-->
              <h6>
                <b>Notes menu</b>
              </h6>
              <h6>
                This section allows you to enter any notes that are necessary to explain the entries in the Financial Statements.
              </h6>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
              <!--<h5 class="fw-bolder font-size-16">Indicates Mandatory field<span class="text-dark">*</span></h5>-->
              <h6>
                Tick the appropriate box(es) below to include the entries in the Financial Statements. Mandatory boxes have been pre-selected and cannot be deselected.
              </h6>
            </div>
            <h6>
              <b>Notes sections</b>
            </h6>
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Notes sections</h5>-->

            </div>
          </div>
          <div class="row justify-center-content">
            <div class="col-12 col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="border border-transparent mt-3" style="height: auto !important">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4" *ngFor="let notes of NotesList">
                    <div class="mt-3">
                      <input type="checkbox" class="mx-2 " [checked]="notes.IsChecked" [disabled]="notes.isDisabled" (change)="notesCheck($event,notes.MasterId)" />
                      <label>{{notes.NotesDescription}}</label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-12 col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="row pt-5">
                <div class="col-12 col-xxl-4 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                  <div class="col-sm-12 col-md-12 col-xxl-7 col-xl-12 col-lg-12 col-12">
                    <label>Jump to next section</label>
                  </div>
                </div>
                <div class="col-12 col-xxl-8 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                  <select class="form-select" (change)="jumpNextSection($event)">
                    <option *ngFor="let jump of NotejumpList">{{jump.NotesDescription}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12  mt-5">
              <div class="row">
                <div class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                  <!--<button type="button" class="btn btn-info p-1 ps-3 pe-3 mx-1">Help</button>-->
                </div>
                <div class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 text-end">
                  <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="goBack($event)">Back</button>
                  <button type="button" class="btn themedefault p-1 ps-3 pe-3 me-0 ms-1" (click)="validationsOfNotesDeselection($event)">Next</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</div>




















